import { DateTime } from 'luxon';

export enum AquaVersionType {
  V1 = 'V1',
  V2 = 'V2',
  V3 = 'V3',
  V4 = 'V4',
}

const versionStartDates = {
  V1: DateTime.fromJSDate(new Date('2000-01-01 00:00:00.000')),
  V2: DateTime.fromJSDate(new Date('2022-11-01 00:00:00.000')),
  V3: DateTime.fromJSDate(new Date('2024-01-31 00:00:00.000')),
  V4: DateTime.fromJSDate(new Date('2026-01-01 00:00:00.000')),
};

export const getAquaVersion = (date: DateTime): AquaVersionType => {
  if (date >= versionStartDates.V4) return AquaVersionType.V4;
  if (date >= versionStartDates.V3) return AquaVersionType.V3;
  if (date >= versionStartDates.V2) return AquaVersionType.V2;
  if (date >= versionStartDates.V1) return AquaVersionType.V1;
  return AquaVersionType.V1;
};
